import listReducer from './reducer'
import ConnectedPagination from './ConnectedPagination.jsx'
import ConnectedList from './ConnectedList.jsx'

/**
 * Integrate a paginated list into an app. List items will probably be
 * IDs that are then mapped to entities in the app's state.
 */

export * from './actions'
export * from './sagas'

export { listReducer, ConnectedPagination, ConnectedList }
